import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronRight } from 'lucide-react';
import { FieldExplainer, type ExplainerSection } from './FieldExplainer';

/**
 * The field explainer of the empty state, kept reachable once the table has
 * taken over — collapsed by default so it doesn't push the data down.
 */
export function CollapsibleFieldExplainer({
  headingKey,
  sections
}: {
  headingKey: string;
  sections: ExplainerSection[];
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-xl border border-line bg-white">
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
        className="flex w-full items-center gap-2 px-4 py-3 text-left"
      >
        <ChevronRight
          className={`h-4 w-4 text-fg-subtle transition-transform ${open ? 'rotate-90' : ''}`}
        />
        <span className="text-sm font-semibold text-foreground">{t(headingKey)}</span>
      </button>
      {open && (
        <div className="px-4 pb-4">
          <FieldExplainer sections={sections} />
        </div>
      )}
    </div>
  );
}
